import styled, { useTheme } from 'styled-components'
import { useRef, useState, useEffect, ReactElement } from 'react'
import { useGetSize } from 'Hooks/useGetSize'
import * as d3 from 'd3'
import { GridLine } from 'theme/styles'

const Sondages = () => {
  //const { breakpoints } = useTheme()
  //const isMobile = useMediaQuery(breakpoints.only('md'))
  const [data, setData] = useState<PollsData[]>([])

  const isMobile = window.innerWidth < 768
  const containerRef = useRef<HTMLDivElement>(null)
  const svgRef = useRef<SVGSVGElement>(null)
  const { width } = useGetSize(containerRef)
  const height = isMobile ? width * 1.2 : width * 0.4

  const xDomain = [35, 75]
  const yDomain = [data.length, 0]
  const margin = {
    top: 40,
    right: 30,
    bottom: 13,
    left: isMobile ? 120 : 200,
  }
  const tickXLength = 12

  const xScale = d3
    .scaleLinear()
    .domain(xDomain)
    .range([margin.left, width - margin.right])

  const yScale = d3
    .scaleLinear()
    .domain(yDomain)
    .range([height - margin.bottom, margin.top])

  const xTicks = isMobile ? [40, 50, 60, 70] : [40, 50, 60, 70]

  console.log(data)

  useEffect(() => {
    d3.csv<PollsData>(
      `${
        process.env.NODE_ENV === 'production'
          ? 'https://dev-interaktiv-mf.tagesanzeiger.ch/2024/votations-federales-avs'
          : ''
      }/sondages.csv`,
      (d) => {
        return {
          name: d['name_fr'],
          result: +d['result'],
          leewas: +d['leewas'],
          gfsbern: +d['gfsbern'],
          closest: d['closest'],
          diffLeewas: +d['leewas diff'],
          diffGfsbern: +d['gfsbern diff'],
          diffLeewasGfsbern: +d['leewas-gfsbern diff'],
        }
      }
    )
      .then((data) => {
        setData(data.slice(0, 12))
      })
      .catch((error) => {
        console.error('Error fetching the CSV data:', error)
      })
  }, [])

  return (
    <Container ref={containerRef}>
      <Svg ref={svgRef} width={width} height={height}>
        {/* Y grid */}
        {xTicks.map((value) => (
          <GridLine
            x1={xScale(value)}
            x2={xScale(value)}
            y1={margin.top - 12}
            y2={height - margin.bottom}
          />
        ))}

        {/* X ticks */}
        {/* {xTicks.map((value) => (
          <Tick
            x1={xScale(value)}
            x2={xScale(value)}
            y1={height - margin.bottom + tickXLength}
            y2={height - margin.bottom}
          />
        ))} */}

        {/* X grid */}
        {data.map((d, i) => {
          return (
            <GridLine
              x1={margin.left}
              x2={width - margin.right}
              y1={yScale(i)}
              y2={yScale(i)}
            />
          )
        })}

        {/* Y ticks */}
        {/* {yTicks.map((value) => {
          return (
            <Tick
              x1={margin.left - tickYLength - 20}
              x2={margin.left - 20}
              y1={yScale(value)}
              y2={yScale(value)}
            />
          )
        })} */}

        {data.map((d, i) => {
          console.log(d.name, i)
          return (
            <>
              <RangeLine
                x1={xScale(d.leewas)}
                x2={xScale(d.gfsbern)}
                y1={yScale(i)}
                y2={yScale(i)}
              />
              <RangeCircleA r={7} cx={xScale(d.leewas)} cy={yScale(i)} />
              <RangeCircleB r={7} cx={xScale(d.gfsbern)} cy={yScale(i)} />
              {/* <RangeCircleD r={3} cx={xScale(d.result)} cy={yScale(i)} /> */}
            </>
          )
        })}

        {/* <BottomLine
          x1={0}
          x2={width - margin.right}
          y1={height - margin.bottom}
          y2={height - margin.bottom}
        /> */}

        {/* <Marker
          x1={xScale(92)}
          x2={xScale(92)}
          y1={margin.top}
          y2={height - margin.bottom}
        /> */}

        <LineRange
          x1={xScale(data[0]?.leewas)}
          x2={xScale(data[0]?.leewas)}
          y1={20}
          y2={30}
        />

        <LineRange
          x1={xScale(data[0]?.gfsbern)}
          x2={xScale(data[0]?.gfsbern)}
          y1={20}
          y2={30}
        />
      </Svg>

      {/* Y labels */}
      {data.map((d, i) => (
        <Label
          style={{
            top: yScale(i),
            left: 0,
            transform: 'translateY(-50%)',
            textAlign: 'left',
          }}
        >
          {d.name}
        </Label>
      ))}

      <LabelA
        style={{
          top: 10,
          left: xScale(data[0]?.gfsbern),
          transform: 'translateY(-50%)',
          textAlign: 'left',
          width: 250,
        }}
      >
        gfs.bern
      </LabelA>

      <LabelB
        style={{
          top: 10,
          left: xScale(data[0]?.leewas),
          transform: 'translate(-100%, -50%)',
          textAlign: 'right',
          width: 1000,
        }}
      >
        LeeWas
      </LabelB>

      {data.map((d, i) => (
        <RangeLabel
          style={{
            top: yScale(i),
            left: xScale(d.gfsbern) + 10,
            height: 20,
            transform: 'translateY(-50%)',
            textAlign: 'left',
            width: 30,
          }}
        >
          +{d.diffLeewasGfsbern}%
        </RangeLabel>
      ))}

      {/* X labels */}
      {xTicks.map((value) => (
        <LabelX style={{ left: xScale(value), top: height }}>
          {value === 0 ? `0` : `${value}%`}
        </LabelX>
      ))}

      {/* <MainNote
        style={{
          top: yScale(50000),
          left: xScale(30),
        }}
      >
        Répartition de la population <strong>en {year}</strong>
      </MainNote> */}
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  position: relative;
  margin: auto;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: calc(100% - 4rem);
    margin: auto;
  }
`

const AgePathLine = styled.path`
  stroke: ${({ theme }) => `rgb(${theme.mainColor})`};
  stroke-width: 3px;
  fill: none;
`

const RangeCircleA = styled.circle`
  fill: ${({ theme }) => theme.textColor};
  stroke: none;
`

const RangeCircleB = styled.circle`
  fill: ${({ theme }) => `rgb(${theme.mainColor})`};
  stroke: none;
`

const LineRange = styled.line`
  stroke: ${({ theme }) => theme.greyDark};
  stroke-width: 1px;
`

const RangeCircleD = styled.circle`
  fill: ${({ theme }) => `#333333`};
  stroke: none;
`

const AgePathLineMen = styled(AgePathLine)`
  stroke: ${({ theme }) => `rgb(${theme.mainColor}, 0.5)`};
`

const RangeLine = styled.line`
  stroke-width: 8px;
  stroke: ${({ theme }) =>
    theme.colorMode === 'light' ? `#33333322` : '#ffffff33'};
  fill: none;
`

const Area = styled.path<{ highlight: boolean }>`
  stroke: none;
  fill: ${({ theme, highlight }) =>
    `rgb(${!highlight ? theme.mainColor : '200, 200, 200'}, 0.5)`};
  transition: fill 0.3s;
`

const OriginalPath = styled(Area)`
  stroke: none;
  fill: #22335511;
`

const Tick = styled.line`
  stroke: var(--text-color);
  stroke-width: 1.25px;
`

const Marker = styled.line`
  stroke: var(--text-color);
  stroke-width: 2px;
  stroke-dasharray: 2px 5px;
  stroke-linecap: round;
`

const MainNote = styled.div`
  width: 150px;
  letter-spacing: 0.05em;
  line-height: 1.2;
  text-align: left;
  position: absolute;
  // text-shadow:
  //   1px 1px 0 #ffffff88,
  //   -1px 1px 0 #ffffff88,
  //   -1px -1px 0 #ffffff88,
  //   1px -1px 0 #ffffff88;
`

const MarkerArea = styled.rect`
  fill: #202346;
  opacity: 0.05;
  stroke: none;
`

const BabyBoomerArea = styled.rect`
  fill: ${({ theme }) => `rgb(${theme.mainColor}, 0.2)`};
  stroke: none;
  mix-blend-mode: multiply;
`

const RangeLabel = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  color: ${({ theme }) => `rgb(${theme.mainColor})`};
  font-size: 0.8em;
`

const BottomLine = styled.line`
  stroke: var(--text-color);
  stroke-width: 1.25px;
`

const Label = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  color: var(--text-color);
  transform: translate(-50%, -50%);
  font-size: 0.8em;
  line-height: 1.1;
  width: 200px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 110px;
    font-size: 0.7em;
  }
`

const LabelX = styled(Label)`
  color: ${({ theme }) => theme.greyDark};
  width: auto;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: auto;
  }
`

const LabelA = styled(Label)`
  color: ${({ theme }) => `rgb(${theme.mainColor})`};
`

const LabelB = styled(Label)`
  color: ${({ theme }) => theme.textColor};
  width: 100px;
  text-align: right;
  transform: translateX(-100%);
`

const Svg = styled.svg``

export default Sondages
